import React, { useState, useEffect } from 'react';
import RichText from '../';
import contentfulRichTextOptions from 'components/RichText/options/contentfulRichTextOptions';
import { ContentfulRichTextContainer } from './styles';
import StyledRichText from '../StyledRichText';
import parseRichTextArticle from 'utils/parseRichTextArticle';
import TableOfContents from 'components/BlogDetailsTemplate/BlogTableOfContents';
import { Row, Col } from 'antd';
import RichTextTableOfContents from './TableOfContents';
import TocRichText from './TableOfContents/TocRichText';

const ContentfulRichText = ({ richText, dataPosition }) => {
  const [toc, setToc] = useState(null);
  const [body, setBody] = useState(null);
  const {
    content,
    styles,
    tableOfContents: useSideBarToC,
    blogContentStyling,
    textAlignment,
    alignmentDesktop,
    alignmentMobile,
    listIcon,
  } = richText || {};

  const containerStyles = {
    ...styles,
    textAlignment: textAlignment,
    alignDesktop: alignmentDesktop,
    alignMobile: alignmentMobile,
    listIcon: listIcon,
  };
  const optionsContent = { ...richText, dataPosition };
  const backgroundImageUrl = containerStyles?.backgroundImage?.image?.file?.url;

  useEffect(() => {
    const richText = content;
    const parsedBlog = parseRichTextArticle(richText, useSideBarToC ? 'v2' : 'v1');

    setToc(parsedBlog.toc);
    setBody(parsedBlog.body);
  }, []);

  const Content = useSideBarToC ? (
    <TocRichText content={body} className="styled-rich-text" />
  ) : blogContentStyling ? (
    <StyledRichText content={body} className="styled-rich-text" />
  ) : (
    <RichText content={body} options={contentfulRichTextOptions(optionsContent)} />
  );

  return (
    <ContentfulRichTextContainer backgroundImageUrl={backgroundImageUrl} {...containerStyles}>
      {toc ? (
        !useSideBarToC ? (
          <>
            <TableOfContents content={toc} />
            {Content}
          </>
        ) : (
          useSideBarToC && (
            <Row style={{ width: '100%' }} gutter={[24, 0]}>
              <Col xs={24} sm={24} md={16} lg={16}>
                {Content}
              </Col>
              <Col xs={0} sm={0} md={8} lg={8}>
                <RichTextTableOfContents data={toc} min={4} max={7} classNames="richtext-toc" />
              </Col>
            </Row>
          )
        )
      ) : (
        Content
      )}
    </ContentfulRichTextContainer>
  );
};

export default ContentfulRichText;
